module.exports = __webpack_public_path__ + "static/media/vermi_growth.b09e2c1c.png";